import { brand, hexToRgb } from './brand';

// Colores del PDF (arreglos RGB para jsPDF) tomados de la marca activa.
export const pdfColors = {
  band: hexToRgb(brand.colors.band),
  primary: hexToRgb(brand.colors.primary),
  onPrimary: hexToRgb(brand.colors.onPrimary),
  text: hexToRgb(brand.colors.text),
};

// Encabezado común de los PDF: banda de marca, nombre, subtítulo y título «COTIZACIÓN».
export function buildPdfHeader(doc) {
  doc.setFillColor(...pdfColors.band);
  doc.rect(0, 0, 210, 35, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text(brand.pdf.title, 105, 15, { align: 'center' });
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text(brand.pdf.subtitle, 105, 22, { align: 'center' });
  doc.setTextColor(...pdfColors.text);
  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('COTIZACIÓN', 105, 50, { align: 'center' });
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
}
